import { render } from "./ControlButtons.vue?vue&type=template&id=b518a168&scoped=true&bindings={\"gameStatus\":\"props\",\"highlightingThings\":\"props\",\"fileMenuIsOpen\":\"props\",\"optionsMenuIsOpen\":\"props\"}"
import script from "./ControlButtons.vue?vue&type=script&lang=js"
export * from "./ControlButtons.vue?vue&type=script&lang=js"

import "./ControlButtons.vue?vue&type=style&index=0&id=b518a168&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b518a168"

export default script